import React, { useState, useEffect } from 'react';
import './printmodal.css';

export default function PrintModal({ isOpen, onClose, relatorio, onGeneratePDF }) {
  const [printOption, setPrintOption] = useState('current');
  const [isGenerating, setIsGenerating] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState('');
  const [availablePeople, setAvailablePeople] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    if (isOpen && relatorio) {
      const people = new Set();
      
      relatorio.report.forEach(entry => {
        const locations = ['atriu', 'corredor', 'banheiro', 'estacionamento', 'som'];
        locations.forEach(loc => {
          if (entry[loc] && Array.isArray(entry[loc])) {
            entry[loc].forEach(person => {
              if (person && person.name) {
                people.add(person.name);
              }
            });
          }
        });
      });

      setAvailablePeople(Array.from(people).sort());

      if (relatorio.report && relatorio.report.length > 0) {
        const dates = relatorio.report.map(r => new Date(r.date)).sort((a, b) => a - b);
        const firstDate = dates[0];
        const lastDate = dates[dates.length - 1];
        
        setStartDate(firstDate.toISOString().split('T')[0]);
        setEndDate(lastDate.toISOString().split('T')[0]);
      }
    }
  }, [isOpen, relatorio]);

  if (!isOpen) return null;

  const handleGeneratePDF = async () => {
    if (printOption === 'individual' && !selectedPerson) {
      alert('Por favor, selecione uma pessoa para imprimir.');
      return;
    }

    if (!startDate || !endDate) {
      alert('Por favor, selecione as datas de início e fim.');
      return;
    }

    if (new Date(startDate) > new Date(endDate)) {
      alert('A data de início não pode ser maior que a data de fim.');
      return;
    }

    setIsGenerating(true);
    try {
      await onGeneratePDF(printOption, selectedPerson, startDate, endDate);
    } catch (error) {
      console.error('Erro ao gerar PDF:', error);
    } finally {
      setIsGenerating(false);
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Opções de Impressão</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <div className="print-options">
            <label className="print-option">
              <input
                type="radio"
                name="printOption"
                value="current"
                checked={printOption === 'current'}
                onChange={(e) => setPrintOption(e.target.value)}
              />
              <span>Esse relatório</span>
            </label>

            <label className="print-option">
              <input
                type="radio"
                name="printOption"
                value="individual"
                checked={printOption === 'individual'}
                onChange={(e) => setPrintOption(e.target.value)}
              />
              <span>Individual (por pessoa)</span>
            </label>

            <label className="print-option">
              <input
                type="radio"
                name="printOption"
                value="igreja"
                checked={printOption === 'igreja'}
                onChange={(e) => setPrintOption(e.target.value)}
              />
              <span>Por igreja</span>
            </label>
          </div>

          {printOption === 'individual' && (
            <div className="person-select-container">
              <label htmlFor="person-select">Selecione a pessoa:</label>
              <select
                id="person-select"
                value={selectedPerson}
                onChange={(e) => setSelectedPerson(e.target.value)}
                className="person-select"
              >
                <option value="">Selecione uma pessoa</option>
                {availablePeople.map((person, index) => (
                  <option key={index} value={person}>
                    {person}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="date-range-container">
            <div className="date-input-group">
              <label htmlFor="start-date">Data de início:</label>
              <input
                type="date"
                id="start-date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="date-input"
              />
            </div>

            <div className="date-input-group">
              <label htmlFor="end-date">Data de fim:</label>
              <input
                type="date"
                id="end-date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="date-input"
              />
            </div>
          </div>

          {relatorio && (
            <div className="relatorio-info">
              <p><strong>Relatório:</strong> {relatorio.nomeRelatorio}</p>
              <p><strong>Igreja:</strong> {relatorio.igrejaName}</p>
              <p><strong>Cidade:</strong> {relatorio.cidadeName}</p>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose}>
            Cancelar
          </button>
          <button 
            className="btn-generate" 
            onClick={handleGeneratePDF}
            disabled={isGenerating}
          >
            {isGenerating ? 'Gerando...' : 'Gerar PDF'}
          </button>
        </div>
      </div>
    </div>
  );
}
